/* eslint-disable import/prefer-default-export */
/**
 * Check  if string value is empty.
 * @param {String} value
 * @returns {Boolean}
 */
export const checkIfEmpty = (value) => {
  return value === '';
};
